export default "__VITE_ASSET__41yqXJ7mv81Xe$0C6CBOlA__"